import { all, takeLatest } from 'redux-saga/effects';

import {
  resendPasswordResetEmailRequest,
  resendVerifyAccountEmailRequest,
  signOutRequest,
} from './auth-slice';
import { logoutSaga } from './logoutSaga';
import { recoverPasswordFlow } from './recoverPasswordSaga';
import { resendVerificationEmailSaga } from './resendEmailsSaga';
import { signInFlow } from './signInSaga';
import { signUpFlow } from './signUpSaga';
import { updatePasswordFlow } from './updatePasswordSaga';
import { validateResetTokenFlow } from './validateResetTokenSaga';
import { verifyAccountFlow } from './verifyAccountSaga';

export default function* authSaga() {
  yield all([
    signUpFlow(),
    signInFlow(),
    recoverPasswordFlow(),
    validateResetTokenFlow(),
    updatePasswordFlow(),
    verifyAccountFlow(),
    takeLatest(
      [resendPasswordResetEmailRequest, resendVerifyAccountEmailRequest],
      resendVerificationEmailSaga
    ),
    takeLatest(signOutRequest, logoutSaga),
  ]);
}
